export interface OidcConfig {
  authority: string
  client_id: string
  redirect_uri: string
  response_type: string
  scope: string
  post_logout_redirect_uri?: string
  silent_redirect_uri?: string
  automaticSilentRenew?: boolean
  loadUserInfo?: boolean
  monitorSession?: boolean
}

/** Set by `public/runtime-config.js` (loaded in index.html before the app). */
declare global {
  interface Window {
    __RUNTIME_OIDC__?: {
      VITE_OIDC_AUTHORITY?: string
      VITE_OIDC_CLIENT_ID?: string
    }
  }
}

function runtimeOidcString(
  key: 'VITE_OIDC_AUTHORITY' | 'VITE_OIDC_CLIENT_ID',
  envFallback: string | undefined,
  defaultValue: string,
): string {
  const raw = window.__RUNTIME_OIDC__?.[key]?.trim()
  if (raw) return raw
  return envFallback || defaultValue
}

// Default production OIDC configuration
const defaultOidcConfigValues: OidcConfig = {
  authority: 'https://ibis.crcredit.cz/apps/klient/',
  client_id: '1',
  redirect_uri: `${window.location.origin}/callback`,
  response_type: 'code',
  scope: 'openid profile email offline_access',
  post_logout_redirect_uri: `${window.location.origin}/logout`,
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
  automaticSilentRenew: true,
  loadUserInfo: false,
  monitorSession: true,
}

// OIDC: runtime-config.js → Vite env → defaults
export const oidcConfig: OidcConfig = {
  ...defaultOidcConfigValues,
  authority: runtimeOidcString(
    'VITE_OIDC_AUTHORITY',
    import.meta.env.VITE_OIDC_AUTHORITY,
    defaultOidcConfigValues.authority,
  ),
  client_id: runtimeOidcString(
    'VITE_OIDC_CLIENT_ID',
    import.meta.env.VITE_OIDC_CLIENT_ID,
    defaultOidcConfigValues.client_id,
  ),
  redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI || defaultOidcConfigValues.redirect_uri,
  post_logout_redirect_uri:
    import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI || defaultOidcConfigValues.post_logout_redirect_uri,
  silent_redirect_uri:
    import.meta.env.VITE_OIDC_SILENT_REDIRECT_URI || defaultOidcConfigValues.silent_redirect_uri,
}

// Export as defaultOidcConfig for backward compatibility (used in useAuth.ts)
export const defaultOidcConfig = oidcConfig
